module.exports = __webpack_public_path__ + "img/honor_004.378c6bf.webp";